import { DatePicker } from "antd";
import { rangePresets } from "../../../../utils/utilHelpers";
import "../../../../assets/css/components/DatePicker.css";
import { useState } from "react";
import moment from "moment";
import styled from "styled-components";

const StyledPage = styled.div`
    &.disabled * {
        cursor: not-allowed;
    }

    .dashboard-custom-date-picker.disabled {
        cursor: not-allowed;
        //opacity: 0.8;
        color: var(--text-icons-gray-300);
    }
`;

const DatePickerComponent = ({ disabled = false }) => {
    const { RangePicker } = DatePicker;
    const [firstDateString, setFirstDateString] = useState("6 March 2025");
    const [secondDateString, setSecondDateString] = useState("6 March 2025");

    const onRangeChange = (dates, dateStrings) => {
        if (dates) {
            setFirstDateString(dateStrings[0]);
            setSecondDateString(dateStrings[1]);
        }
    };

    const formattedFirstDate = moment(firstDateString).format("DD MMMM YYYY");
    const formattedSecondDate = moment(secondDateString).format("DD MMMM YYYY");

    return (
        <StyledPage className={`${disabled ? "disabled" : ""}`}>
            <RangePicker
                presets={rangePresets}
                onChange={onRangeChange}
                popupStyle={{
                    position: "absolute",
                    left: "280px"
                }}
                style={{
                    opacity: "0",
                    position: "absolute"
                }}
                popupClassName={`range-picker-pop-up ${disabled ? "d-none" : ""}`}
            />
            <div className={`dashboard-custom-date-picker ${disabled ? "disabled" : ""}`}>
                <i className="fa-light fa-calendar"></i>
                <div className="dates-wrapper">
                    <div>{formattedFirstDate}</div>-<div>{formattedSecondDate}</div>
                </div>
                <i className="fa-light fa-chevron-down"></i>
            </div>
        </StyledPage>
    );
};

export default DatePickerComponent;
